import React, { Component } from 'react';
import { Switch, Route, withRouter } from 'react-router-dom';
import { Link, BrowserRouter as Router } from 'react-router-dom';
import Api from './BackendApiView';
import $ from 'jquery';
import Slu from './intent/Slu';
import Dsm from './transition/Dsm';
import DsmSubTabsPage from './transition/DsmSubTabsPage';
class tabs extends Component {
  componentDidMount() {
    (function () {
      var currentPath = window.location.href;
      var path = window.origin + "/platform/projectmgmt/nlutab";
      var path1 = window.origin + "/platform/projectmgmt/nlutab/";
      if (currentPath === path || currentPath === path1) {
        $("#intent-tab").addClass('active');
      } else if (currentPath.includes('/nlutab/dsm')) {
        $("#dsm-tab").addClass('active');
      } else if (currentPath.includes('/nlutab/backend-api')) {

        $("#backend-api-tab").addClass('active');
      } else {
        $("#" + localStorage.getItem("last-used-nlu-tab")).addClass('active')
      }
      $("#intent-tab,#dsm-tab,#backend-api-tab")
        .on("click", function () {
          $("#intent-tab,#dsm-tab,#backend-api-tab")
            .removeClass('active');
          localStorage.setItem("last-used-nlu-tab", $(this)[0].id);
          $(this).addClass('active')

        })

      $("#dsm-tab").on("click", function () {
        $("#dialog-state-transition-tab,#dialog-state-graph-tab")
          .removeClass('active');
        $("#dialog-state-transition-tab").addClass('active');
      })

    })();
  }
  render() {
    return (

      <div id="tabPage" >
        <div className="content" >

          <link rel="shortcut icon" type="image/png" href="assets/images/bot.ico" />
          <title> Dheeyantra | Clusters Details</title>
          {/* Font Awesome Icons */}
          <link rel="stylesheet" href="plugins/font-awesome/css/font-awesome.min.css" />
          {/* IonIcons */}
          <link rel="stylesheet" href="//code.ionicframework.com/ionicons/2.0.1/css/ionicons.min.css" />
          <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
          {/* Theme style */}
          <link rel="stylesheet" href="assets/css/adminlte.css" />
          <link href="https://cdn.jsdelivr.net/npm/gijgo@1.9.6/css/gijgo.min.css" rel="stylesheet" />
          <link rel="stylesheet" href="assets/css/custom-style.css" />
          <link rel="stylesheet" href="assets/css/styles.css" />
          <link rel="stylesheet" href="assets/css/custom-style.css" />
          <div className="content-header" >
            <div className="container-fluid">
              <div className="row">
                <div className="col-sm-5">
                  <h1 className="m-0 page-title">Intents &amp; Automations</h1>
                  <h6 className="taglineTxt">Natural Language Understanding</h6>
                </div>
              </div>
            </div>
          </div>
          <div className="container-fluid" >
            <div className="border-bottom"></div>
            {/* Nav tabs */}
            <div className="tab-class">

              <ul className="nav nav-tabs border-bottom navCluster" style={{ marginLeft: '5px' }} >
                <Link className="nav-item" data-toggle="tab"
                  to="/projectmgmt/nlutab" style={{ textDecoration: 'none' }}>
                  <li className="nav-link" id="intent-tab">
                    Intents
                  </li></Link>
                <Link data-toggle="tab" to="/projectmgmt/nlutab/dsm" className="nav-item"
                  style={{ textDecoration: 'none' }} >
                  <li className="nav-link" id="dsm-tab">
                    Skills/DSM
                  </li>
                </Link>
                <Link data-toggle="tab" to="/projectmgmt/nlutab/backend-api"
                  className="nav-item" style={{ textDecoration: 'none' }} >
                  <li className="nav-link" id="backend-api-tab">
                    Backend API
                  </li></Link>
              </ul>
            </div>
          </div>
        </div>
        <Switch >
          <Route path="/projectmgmt/nlutab/dsm" component={DsmSubTabsPage}></Route>
          <Route path="/projectmgmt/nlutab/backend-api" component={Api}></Route>
          <Route path="/projectmgmt/nlutab" component={Slu}></Route>
        </Switch>

      </div>

    );
  }
}
export default tabs;


// WEBPACK FOOTER //
// ./src/projectmgmt/nlu/tabs.js